function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import lazyGettext from 'js-utils/lazy-gettext';
import CopyButton from './CopyButton';
import withTooltip from '../tooltip/withTooltip';
import { VALID_DIRECTIONS } from '../tooltip/constants';
import { renderIconButton } from './constants';

var _getTooltipText = function _getTooltipText(hasCopied, tooltipText, tooltipSuccessText) {
  if (hasCopied) {
    return tooltipSuccessText;
  }

  return tooltipText;
};

var CopyButtonWrapper = function CopyButtonWrapper(_ref) {
  var children = _ref.children;
  return children;
};

var CopyButtonWithTooltipComponent = withTooltip(CopyButtonWrapper);

var CopyButtonWithTooltip =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CopyButtonWithTooltip, _PureComponent);

  function CopyButtonWithTooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyButtonWithTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyButtonWithTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onRender", function (hasCopied) {
      var _this$props = _this.props,
          tooltipText = _this$props.tooltipText,
          tooltipSuccessText = _this$props.tooltipSuccessText,
          tooltipArrowLocation = _this$props.tooltipArrowLocation,
          tooltipId = _this$props.tooltipId,
          __tooltipContainerClassName = _this$props.__tooltipContainerClassName,
          render = _this$props.render;

      var tooltipTextToRender = _getTooltipText(hasCopied, tooltipText, tooltipSuccessText);

      return React.createElement(CopyButtonWithTooltipComponent, {
        toolTipArrowLocation: tooltipArrowLocation,
        tooltipId: tooltipId,
        tooltipText: tooltipTextToRender,
        __containerClassName: __tooltipContainerClassName
      }, render(hasCopied));
    });

    return _this;
  }

  _createClass(CopyButtonWithTooltip, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          onCopyClick = _this$props2.onCopyClick;
      return React.createElement(CopyButton, {
        render: this.onRender,
        value: value,
        onCopyClick: onCopyClick
      });
    }
  }]);

  return CopyButtonWithTooltip;
}(PureComponent);

_defineProperty(CopyButtonWithTooltip, "propTypes", {
  /**
   * The text to copy
   */
  value: PropTypes.string.isRequired,

  /**
   * The id for the tooltip
   */
  tooltipId: PropTypes.string.isRequired,

  /**
   * Callback function called if the user clicks on the copy button
   */
  onCopyClick: PropTypes.func,

  /**
   * The direction that the tooltip should appear in relative to the icon
   */
  tooltipArrowLocation: PropTypes.oneOf(VALID_DIRECTIONS),

  /**
   * Render function for the copy button contents (defaults to an Icon Button with copy icon)
   */
  render: PropTypes.func,

  /**
   * Classes to be passed down to the tooltip container hoc to be applied to its container class.
   */
  __tooltipContainerClassName: PropTypes.string,

  /**
   * Text displayed in tooltip on initial hover
   */
  tooltipText: EBPropTypes.translation,

  /**
   * Text displayed in tooltip when copy is successful
   */
  tooltipSuccessText: EBPropTypes.translation
});

_defineProperty(CopyButtonWithTooltip, "defaultProps", {
  tooltipArrowLocation: 'bottom',
  tooltipText: lazyGettext('Copy'),
  tooltipSuccessText: lazyGettext('Copied'),
  render: renderIconButton
});

export { CopyButtonWithTooltip as default };